import { OnDestroy } from "@angular/core";
import { SCBaseService } from "@symblcrowd/ng-symblcrowd";

export class BaseService extends SCBaseService implements OnDestroy {
    ngOnDestroy() {
        super.ngOnDestroy()
    }
}